module.exports = __webpack_public_path__ + "img/xqimg5.3f95ed01.png";